(function ($, ns) {
  "use strict";

  var moduleFaq = function (context, opts) {
    this.$context = $(context);

    var defaultOpts = {
      pushState: (ns.faq && ns.faq.opts && ns.faq.opts.pushState !== undefined) ? ns.faq.opts.pushState : true
    };
    opts = opts || {};
    this.opts = $.extend(defaultOpts, opts);

    this.init();
  };

  moduleFaq.prototype = {
    init: function () {
      var self = this;
      self.registerEvents();

      if (this.opts.pushState) {
        window.history && history.replaceState({'module': 'faq', 'href': window.location.href}, null, window.location.href);
        window.onpopstate = function (event) {
          if (event.state && event.state.module && event.state.module === 'faq' && event.state.href) {
            self.loadPage(event.state.href);
          }
        }
      }

      self.recomputeIndexes();
    },
    registerEvents: function () {
      this.registerPagination();
      this.registerSearch(true);
      this.registerReset();
    },
    recomputeIndexes: function () {
      jQuery('.module-faq').each(function (i, instance) {
        $(instance).data('index', i);
      });
    },
    loadPage: function (href, cb) {
      var self = this;
      self.$context.addClass('ajax-loading');
      $.get(href, {}, function (res) {
        self.$context.removeClass('ajax-loading');
        var index = self.$context.data('index');
        var $newContext = null;
        if (index) {
          $newContext = $($(res).find('.module-faq')[index]);
          $newContext.data('index', index);
        } else {
          $newContext = $(res).find('.module-faq').first();
        }
        self.$context.replaceWith($newContext);
        self.$context = $newContext;

        var topPos = self.$context.offset().top;
        if (window.smoothScrollMargin) {
          topPos -= window.smoothScrollMargin;
        }

        $('html,body').animate({
          scrollTop: topPos
        }, 750);

        self.registerEvents();

        if (self.opts.pushState) {
          window.history && history.pushState({'module': 'faq', 'href': href}, null, href);
        }

        if (ns.theme && ns.theme.runCurrentPageJs) {
          ns.theme.runCurrentPageJs(self.$context);
        }
        if (window.pew) {
          window.pew.enhanceRegistry(self.$context[0]);
        }
        cb && cb();
      });
    },
    registerPagination: function () {
      var self = this;
      this.$context.find('.pagination a.navlink').on('click', function (e) {
        e.preventDefault();
        $(this).replaceWith('<span class="loader loader--small"></span>')
        self.loadPage($(this).attr('href'));
      })
    },
    registerSearch: function (autoSubmit) {
      var self = this,
        $filtersForm = this.$context.find('form.faq-filters');

      $filtersForm.on('submit', function (e) {
        var $form = $(this);
        e.preventDefault();
        if (!self.$context.hasClass('ajax-loading')) {
          self.loadPage($form.prop('action') + '?' + $form.serialize());
        }
      });
      if (autoSubmit) {
        $filtersForm.addClass('auto-submit');
        this.$context.find('.checkbox, input, select').not('.exclude').on('change', function () {
          $(this).parent().addClass('currently-loading');
          $filtersForm.submit();
        });
      }
    },
    registerReset: function () {
      var self = this,
        $filtersForm = this.$context.find('.faq-filters');
      $filtersForm.find('button[type="reset"]').on('click', function () {
        $filtersForm.find('select, input, textarea').val('');
        $filtersForm.submit();
      });
    }
  };

  if (ns && ns.app) {
    ns.app.registerModule('faq', moduleFaq);
  } else {
    window.pew.addRegistryEntry({key: 'wdf-plugin-faq', domSelector: '.module-faq', classDef: moduleFaq});
  }

})(jQuery, window.wonderwp);
